import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from '../../../../core/services/navigation.service';
import { DeploymentService } from 'src/app/core/services/deployment.service';
import { take } from 'rxjs';
import { HeaderService } from 'src/app/core/services/header.service';

@Component({
  selector: 'app-storage-left-panel',
  templateUrl: './storage-left-panel.component.html',
  styleUrls: ['./storage-left-panel.component.scss'],
})
export class StorageLeftPanelComponent implements OnInit {
  properties = [
    {
      name: 'Data-Transfer',
      routerLink: 'data-transfer',
      spanClass: 'bi bi-hdd',
    },
    // {
    //   name: 'Properties',
    //   routerLink: 'properties',
    //   spanClass: 'bi bi-clipboard',
    // },
    {
      name: 'Logs',
      routerLink: 'logs',
      spanClass: 'bi bi-body-text',
    },
  ];

  selectedIndex;
  deploymentName: string;
  queryParam: {} = null;

  constructor(
    private navService: NavigationService,
    private route: ActivatedRoute,
    private router: Router, private deploymentService: DeploymentService, private headerService: HeaderService
  ) {}

  ngOnInit(): void {
    this.navService.sendParentData('Data-Transfer');
    this.navService.index.subscribe((x) => (this.selectedIndex = x));
    this.navService.DeploymentName.pipe(take(1)).subscribe(name => this.deploymentName = name);
    this.deploymentService.AllProfileInfoes.pipe(take(2)).subscribe(prof => {
      if(prof == null) return;
      let profile = prof.find(p => p.name == this.deploymentName);
      let role = this.headerService.getUserRoleForDeployment(this.deploymentName);
      if(role == 3){
        if(profile.showStorageProperties){
          let idx = this.properties.findIndex(prop => prop.name == 'Properties')
          if(idx != -1) return;
          this.properties.splice(1, 0, {
            name: 'Properties',
            routerLink: 'properties',
            spanClass: 'bi bi-clipboard',
          })
        }
      } else {
        let idx = this.properties.findIndex(prop => prop.name == 'Properties')
        if(idx != -1) return;
        this.properties.splice(1, 0, {
          name: 'Properties',
          routerLink: 'properties',
          spanClass: 'bi bi-clipboard',
        })
      }
    })
  }

  sendData(index: number, property) {
    if(index != 0){
      let url = this.router.url.split('/');
      let path = url[url.length - 1];
      if(path.includes("fileShare")) {
        this.queryParam = { fileShare: path.split("=")[1] }
      }
    }
    this.selectedIndex = index;
    this.navService.sendLeftPanelIndex(index);
    this.navService.selectedLogType = "Storage";
    this.navService.sendParentData(property.name);
    if(this.queryParam && index == 0){
      this.router.navigate([property.routerLink], { queryParams: this.queryParam, relativeTo: this.route });
    } else {
      this.router.navigate([property.routerLink],{ relativeTo: this.route })
    }
  }
 
}
